module.exports = __webpack_public_path__ + "img/default-moon.87f55d08.svg";